interface Service {
  icon: string;
  title: string;
  description: string;
  color: string;
}

export default function Services() {
  const services: Service[] = [
    {
      icon: 'ri-music-2-line',
      title: 'Curadoria Artística',
      description: 'Seleção personalizada de repertório e formação musical ideal para cada tipo de evento, garantindo a atmosfera perfeita.',
      color: 'from-amber-500 to-yellow-600'
    },
    {
      icon: 'ri-mic-line',
      title: 'Músicos ao Vivo',
      description: 'Artistas profissionais de alto nível, com experiência em grandes eventos e performances memoráveis que emocionam.',
      color: 'from-yellow-500 to-orange-600'
    },
    {
      icon: 'ri-volume-up-line',
      title: 'Sonorização Profissional',
      description: 'Equipamentos de última geração e técnicos especializados para garantir qualidade sonora impecável em qualquer espaço.',
      color: 'from-orange-500 to-amber-600'
    },
    {
      icon: 'ri-tv-line',
      title: 'Painéis de LED',
      description: 'Tecnologia visual de ponta para criar experiências imersivas e impactantes que complementam perfeitamente a produção musical.',
      color: 'from-amber-600 to-yellow-500'
    }
  ];

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    contactSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="services" className="py-24 px-6 bg-gradient-to-b from-gray-900 to-black">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-amber-500 font-semibold text-sm uppercase tracking-wider">Serviços</span>
          <div className="w-20 h-1 bg-amber-500 mx-auto mt-2 mb-6"></div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Soluções Musicais Completas
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Da concepção à execução, cuidamos de cada detalhe para criar a experiência sonora perfeita
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group relative bg-gradient-to-b from-gray-800 to-gray-900 rounded-2xl p-8 transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-amber-500/20 cursor-pointer"
            >
              {/* Gradient Border Effect */}
              <div className={`absolute inset-0 rounded-2xl bg-gradient-to-r ${service.color} opacity-0 group-hover:opacity-100 transition-opacity duration-300 -z-10 blur-xl`}></div>
              
              {/* Icon */}
              <div className={`w-16 h-16 flex items-center justify-center rounded-full bg-gradient-to-r ${service.color} mb-6 transition-transform duration-300 group-hover:rotate-12`}>
                <i className={`${service.icon} text-3xl text-white`}></i>
              </div>

              {/* Content */}
              <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-amber-500 transition-colors duration-300">
                {service.title}
              </h3>

              <p className="text-gray-400 leading-relaxed">
                {service.description}
              </p>

              {/* Hover Arrow */}
              <div className="mt-6 flex items-center gap-2 text-amber-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <span className="text-sm font-semibold">Saiba mais</span>
                <i className="ri-arrow-right-line"></i>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="mt-16 text-center">
          <button
            onClick={scrollToContact}
            className="px-12 py-5 bg-gradient-to-r from-amber-500 to-yellow-600 text-black font-bold text-xl rounded-full transition-all duration-300 hover:scale-105 hover:shadow-2xl hover:shadow-amber-500/50 whitespace-nowrap cursor-pointer"
          >
            <span className="flex items-center justify-center gap-3">
              Solicite um Orçamento
              <i className="ri-arrow-right-line text-2xl"></i>
            </span>
          </button>
        </div>

        {/* Additional Info */}
        <div className="mt-20 bg-gradient-to-r from-amber-500/10 to-yellow-600/10 rounded-2xl p-12 border border-amber-500/20">
          <div className="grid md:grid-cols-3 gap-8 text-center">
            <div>
              <i className="ri-calendar-check-line text-4xl text-amber-500 mb-4"></i>
              <h4 className="text-xl font-bold text-white mb-2">Planejamento Completo</h4>
              <p className="text-gray-400">Do primeiro contato até o último acorde</p>
            </div>
            <div>
              <i className="ri-star-line text-4xl text-amber-500 mb-4"></i>
              <h4 className="text-xl font-bold text-white mb-2">Qualidade Garantida</h4>
              <p className="text-gray-400">Profissionais experientes e equipamentos premium</p>
            </div>
            <div>
              <i className="ri-heart-line text-4xl text-amber-500 mb-4"></i>
              <h4 className="text-xl font-bold text-white mb-2">Emoção em Cada Nota</h4>
              <p className="text-gray-400">Música que toca o coração e cria memórias</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
